import { useState } from 'react';
import { ArrowRight16 } from '@carbon/icons-react';
import { Button, Loading, ButtonSet } from 'carbon-components-react';
import { segmentTracking } from '../../lib/tracker';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';
import Cookies from 'js-cookie';
import * as URX_FORM from '../../constants/urx-form';
import { initUrxForm } from 'src/common/hooks/widgets/urxForm';
import { useEnv } from 'src/common/hooks/widgets/useEnv';
import { FormModal } from 'src/common/utils/FormModal';
import Helmet from 'react-helmet';
import {
  urxScriptLoader,
  urxScript,
} from 'src/common/hooks/widgets/globalDefinitions';
import { LangDefaults } from 'src/common/hooks/widgets/useLang';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from '../../locales/messages';
import { BPType } from 'src/common/hooks/widgets/useBPName';
import { IBMLocale } from 'src/common/locale/mapValidLocale';

const PageTitle = 'Cognos Analytics Demo';

const NavHeader = ({ bpName, logo, companyId, desc, mssp, params }: BPType) => {
  const cookieURL = useCookiesURL();
  const [environment] = useEnv();
  const [urxlang] = useState(LangDefaults.localCountryLang);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loadIcon, setLoadIcon] = useState(false);
  const intl = useIntl();

  window.onUrxFormSubmitSuccess = () => {
    setDrawerOpen(false);
  };

  const setCookie = () => {
    const getBp = () => {
      if (bpName) return bpName;
      if (logo) return companyId;
      if (desc) return desc;
      if (mssp) return mssp;
      const bpField = document.querySelector('#Q_BPNAME') as HTMLInputElement;
      return bpField ? bpField.value : '';
    };
    const text = JSON.stringify({
      source: URX_FORM.FORM_ID,
      // One field to provide all values (stringify)
      dcq: {
        Q_NOTESDATA:
          cookieURL +
          ' | Show me how -IBM Cognos Analitycs-' +
          ' | FormId:' +
          URX_FORM.FORM_ID +
          (getBp() ? `|Preferred BP:${getBp()}` : ''),
        Q_ASSET_URL: window.location.href + '&cognospromocta2Lnavtour=true ', // ISC - Asset URL
        Q_ASSET_NAME: 'IBM Cognos Analitycs', // ISC - Asset Name
      },
    });
    Cookies.set('urxdcq', text);
    console.log('cookie', Cookies.get('urxdcq'));
  };

  const buyNow = () => {
    let url = '';
    if (params) {
      url =
        'https://www.ibm.com/marketplace/purchase/configuration/en/us/checkout'
          .concat(params)
          .concat('&editionID=EID2RPAX&cognospromocta1Lnavtour=true');
    } else {
      url =
        'https://www.ibm.com/marketplace/purchase/configuration/en/us/checkout?editionID=EID2RPAX&cognospromocta1Lnavtour=true';
    }
    segmentTracking('CTA Clicked', {
      pageTitle: PageTitle,
      object: 'Nav Header',
      resultValue: `Loaded: ${url}`,
      CTA: 'Buy Now page',
      location: 'Cognos Analitycs Demo',
      action: 'Clicked',
      field: '',
    });
    setTimeout(async () => {
      window.open(url);
    }, 250);
  };

  const replaceBpField = () => {
    const bpField = document.getElementById('Q_BPNAME') as HTMLInputElement;

    if (bpName && bpField) {
      //update label text
      const bpLabel = bpField.labels?.length
        ? bpField.labels[0]
        : new HTMLInputElement();
      bpLabel.innerHTML = intl.formatMessage(messages.preferred_bp);

      //replace the bp field by the bp name
      const bpText = document.createElement('p') as HTMLInputElement;
      bpText.innerText = bpName;
      bpText.style.fontSize = '1rem';
      bpText.style.fontWeight = 'bold';
      bpText.style.lineHeight = '2.5';
      bpField.parentNode?.replaceChild(bpText, bpField);
    }
  };

  return (
    <div className="bx--grid" id="Nav-Header">
      <Helmet>
        <script type="application/javascript" src={urxScriptLoader}></script>
        <script type="application/javascript" src={urxScript}></script>
      </Helmet>
      <div className="bx--row nam">
        <div className="bx--col-lg-3 bx--col-md-3 bx--col-sm-3">
          <p className="type2">
            IBM <FormattedMessage {...messages.page_title} />
          </p>
        </div>
        <div className="bx--col-lg-3 bx--col-md-1 bx--col-sm-3">
          <p className="type2"></p>
        </div>
        <div className="bx--col-lg-10 bx--col-md-4 bx--col-sm-2">
          <ButtonSet className="Header__stack-button btn-set">
            <Button
              className="button-header button-header2"
              renderIcon={ArrowRight16}
              kind="tertiary"
              id="cta-buy-now"
              onClick={() => {
                buyNow();
              }}
            >
              <FormattedMessage {...messages.bookDemo} />
            </Button>
            <Button
              className="button-header"
              id="cta-try-free"
              renderIcon={ArrowRight16}
              onClick={() => {
                setLoadIcon(true);
                initUrxForm(
                  environment,
                  URX_FORM.INSTANCE_ID,
                  URX_FORM.FORM_ID,
                  urxlang as IBMLocale,
                  companyId,
                );
                segmentTracking('CTA Clicked', {
                  pageTitle: PageTitle,
                  object: 'Nav Header',
                  resultValue: 'CTA clicked',
                  CTA: 'Show me how CTA',
                  location: 'Cognos Analitycs Demo',
                  action: 'Clicked',
                  field: '',
                });
                setTimeout(
                  async () => {
                    setCookie();
                    replaceBpField();
                    setLoadIcon(false);
                    setDrawerOpen(true);
                  },
                  bpName ? 1000 : 10,
                );
              }}
            >
              <FormattedMessage {...messages.trail} />
            </Button>
          </ButtonSet>
        </div>

        <div className="button-set">{loadIcon ? <Loading /> : null}</div>
        <FormModal
          pageTitle={PageTitle}
          object="URX Form"
          productTitle={'IBM Cognos Analytics'}
          pageUrl={''}
          location={'Demo'}
          bpName={bpName}
          logo={logo}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
        ></FormModal>
      </div>
    </div>
  );
};

export default NavHeader;
